import { Component, Input, ViewContainerRef, TemplateRef, OnInit, AfterViewInit, AfterViewChecked, OnDestroy, ComponentRef, ViewChild, ElementRef, ViewRef } from '@angular/core';


@Component({	
	selector: 'app-key-popup-widget',
	templateUrl: './key-popup-widget.component.html',
	styleUrls: ['./key-popup-widget.component.scss']
})
export class KeyPopupWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
	isPopupShown: boolean = false;	
	@ViewChild('anchorElementRef', { read: ElementRef }) anchorElementRef : ElementRef;

	
	@Input() description: string = "";
	@Input() popupTitle: string = "";

	popperInstance : any = null;

	constructor() {

	}

	ngOnInit(): void {
		
	}		

	ngOnDestroy(): void {			
	}

	ngAfterViewInit(): void {		
		
	}

	closePopup = () => {		
		this.isPopupShown = false;		
	}


	onClick()  {				
		this.isPopupShown = !this.isPopupShown;		
	}

	
	onPopupClose(event : boolean) 
	{
		this.isPopupShown = false;			
	}
}
